//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleThreshold",1,0],[1,"AverageSize",0,"Expression",0],[0,"ChordalTolerance",1,0],[0,"FacetsInGap",1,0],[1,"GapFaces",0,"ScCollector",0],[1,"InputBodyCollector",0,"ScCollector",0],[0,"InputBodyOption",1,0],[1,"IntendedGapSize",0,"Expression",0],[0,"KeepSharpEdges",1,0],[1,"MaxGapSize",0,"Expression",0],[1,"MaximumSize",0,"Expression",0],[0,"Method",1,0],[0,"ProximityRefinement",1,0],[1,"SearchDistance",0,"Expression",0],[1,"SeedPoint",0,"SelectDisplayableObjectList",0],[0,"WrapMeshMode",1,0]],[],[]];
SPLM.Facet.WrapMeshBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.WrapMeshBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.WrapMeshBuilder.MethodType = Object.freeze({
    "External" : "External", "LargestInternal" : "LargestInternal", "InternalBySeedPoint" : "InternalBySeedPoint"});

SPLM.Facet.WrapMeshBuilder.WrapMeshModeType = Object.freeze({
    "Constant" : "Constant", "Variable" : "Variable"});

SPLM.Facet.WrapMeshBuilder.KeepInputBodyType = Object.freeze({
    "Keep" : "Keep", "Hide" : "Hide"});

export default SPLM;